import { Box, Button, Card, Chip, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, InputBase, MenuItem, Paper, patch, Popover, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useState, useRef } from 'react'
import { Helmet } from 'react-helmet-async'
import { toast } from 'react-toastify';
import Iconify from 'src/components/iconify'
import PaginationComponent from 'src/components/pagination';
import { deleteData, getData } from 'src/webService/webService';
import {file_URL} from '../utils/url'

function ProjectsPage() {
  const [leads, setLeads] = useState([]);
  const sessionToken = sessionStorage.getItem("Token");
  const [open, setOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState();

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [details, setDetails] = useState(false);
  const [scroll, setScroll] = useState('paper');
  const descriptionElementRef = useRef(null);
  const [selectedLead, setSelectedLead] = useState(null)

  const handleClickOpen = (scrollType, leadId) => () => {
    const lead = leads.find((data) => data._id === leadId);
    setDetails(true);
    setScroll(scrollType);
    setOpen(null);
    handleCloseMenu();
  };

  const handleDetailsClose = () => {
    setDetails(false);
    setSelectedLead(null);
  };

  useEffect(() => {
    if (details) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [details]);

  const handleOpenMenu = (event, userId) => {
    const lead = leads.find((data) => data._id === userId);
    setOpenMenu(event.currentTarget);
    setSelectedUserId(userId);
    setSelectedLead(lead)
  };

  const handleCloseMenu = () => {
    setOpenMenu(null);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Not Started":
        return "error";
      case "In Progress":
        return "warning";
      case "Completed":
        return "success";
      default:
        return "default";
    }
  };

  const getAllLeads = async (skip, limit) => {

    const params = {
      page: skip,
      limit: limit
    }

    try {
      console.log("Fetching users...");
      console.log("Token being sent:", sessionToken);

      const response = await getData("leads/services", params, sessionToken);
      console.log("Response:", response)

      const responseData = response.data.results[0]?.paginatedResults;
      const convertedLeads = responseData.filter(lead => lead.generalStatus === "Converted");

      setLeads(convertedLeads);
      setTotalPages(response.data.results[0].totalPages)
      setTotalCount(response.data.results[0]?.totalCount?.totalItems || convertedLeads.length);


    } catch (error) {
      console.error("Error fetching users:", error);
    }

  }

  const handleDelete = async (id) => {
    if (!id) {
      console.error("User ID is undefined.");
      return;
    }
    try {
      const response = await deleteData(`leads/lead/${id}`, sessionToken);
      console.log(response.message);
      toast.success("User deleted successfully!");
      setLeads((prevUsers) => prevUsers.filter((user) => user.id !== id));
    } catch (error) {
      console.error("Error deleting user:", error);
      toast.error(`${error ? error : ''}`);
    }
    getAllLeads();
  };

  const handleLimitChange = (event) => {
    setCurrentPage(1);
    if (currentPage === 1) {
      setLimit(event.target.value)
      getAllLeads(1, event.target.value)
    }
    else {
      setCurrentPage(1);
      setLimit(event.target.value);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
      getAllLeads(currentPage - 1, limit);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
      getAllLeads(currentPage + 1, limit);
    }
  };

  const calculateIndex = (index) => {
    return (currentPage - 1) * limit + index + 1;
  };

  useEffect(() => {
    getAllLeads(currentPage, limit);
  }, [currentPage, limit])

  return (
    <>
      <Helmet>
        <title>Projects</title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Projects
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                backgroundColor: "white",
                borderRadius: "15px",
                padding: "4px 12px",
                boxShadow: 1,
                marginRight: "20px"
              }}
            >
              <Iconify icon="eva:search-fill" />
              <InputBase
                placeholder="Search"
                sx={{ marginLeft: "8px" }}
              />
            </Box>
          </Box>
        </Stack>
        <Card sx={{ padding: 1, boxShadow: 3, backgroundColor: "#fff" }}>
          {/* Projects Table */}
          <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>S.No</TableCell>
                  <TableCell>Project Name</TableCell>
                  <TableCell>Client Name</TableCell>
                  <TableCell>Contact</TableCell>
                  <TableCell>Source</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  totalCount === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        No data found
                      </TableCell>
                    </TableRow>
                  ) : (
                    leads.map((leads, id) => (
                      <TableRow key={leads.id}>
                        <TableCell>{calculateIndex(id)}</TableCell>
                        <TableCell>
                          <Typography variant='caption'>{leads.company}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='caption'>{leads.name}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='caption'>{leads.phone}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='caption'>{leads?.source}</Typography>
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={leads?.generalStatus || "Unknown"}
                            color={getStatusColor(leads?.statusHistory?.[leads.statusHistory.length - 1]?.status)}
                          />
                        </TableCell>
                        <TableCell>
                          <Iconify icon="mdi:dots-vertical"
                            sx={{ cursor: 'pointer' }}
                            onClick={(event) => handleOpenMenu(event, leads._id)}
                          />
                        </TableCell>
                      </TableRow>
                    ))
                  )
                }
              </TableBody>
            </Table>
          </TableContainer>

          <PaginationComponent
            name={"Projects"}
            totalcount={totalCount}
            limit={limit}
            handleLimitChange={handleLimitChange}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            currentPage={currentPage}
            totalPages={totalPages}
          />

          <Popover
            open={Boolean(openMenu)}
            anchorEl={openMenu}
            onClose={handleCloseMenu}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
              sx: {
                p: 1,
                width: 170,
                '& .MuiMenuItem-root': {
                  px: 1,
                  typography: 'body2',
                  borderRadius: 0.75,
                },
              },
            }}
          >
            {/* <MenuItem onClick={handleClickOpen('paper')}>
              <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
              View
            </MenuItem> */}
            <MenuItem
              sx={{ color: 'error.main' }}
              onClick={() => {
                if (!selectedUserId) {
                  toast.error('No user selected. Please try again.');
                  return;
                }
                const confirmDelete = window.confirm('Are you sure you want to delete this user?');
                if (confirmDelete) {
                  handleDelete(selectedUserId);
                  handleCloseMenu();
                }
              }}
            >
              <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
              Delete
            </MenuItem>
          </Popover>

        </Card>
      </Container>

      <Dialog
        open={details}
        onClose={handleDetailsClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Leads Details</DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
          >
            {selectedLead ? (
              <>
                <p><strong>Name:</strong> {selectedLead?.name}</p>
                <p><strong>Email:</strong> {selectedLead?.email}</p>
                <p><strong>Phone:</strong> {selectedLead?.phone}</p>
                <p><strong>Company:</strong> {selectedLead?.company}</p>
                <p><strong>General Status:</strong> {selectedLead?.generalStatus}</p>
                <p><strong>Assigned to:</strong> {selectedLead?.assignedTo?.name}</p>
                <p><strong>Service Name:</strong> {selectedLead?.serviceHistory[0]?.serviceName}</p>
                <p><strong>Service History:</strong> {selectedLead?.serviceHistory[0]?.serviceStatus}</p>
                <Button
                  variant='contained'
                  color='primary'
                  href={
                    selectedLead?.serviceHistory[0]?.quotationFileObject?.path
                      ? `${file_URL+encodeURI(selectedLead.serviceHistory[0].quotationFileObject.path.replace("public/", ""))}`
                      : "#"
                  }
                  target='_blank'
                >
                  View Quotation File
                </Button>

              </>
            ) : (
              <p>No lead selected.</p>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDetailsClose}>Close</Button>
        </DialogActions>
      </Dialog>

    </>
  )
}

export default ProjectsPage
